import script from "./PeriodRevenue.vue?vue&type=script&setup=true&lang=js"
export * from "./PeriodRevenue.vue?vue&type=script&setup=true&lang=js"

import "./PeriodRevenue.vue?vue&type=style&index=0&id=64078d9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64078d9c"]])

export default __exports__